import React from 'react'
import { Box } from '../layout'

export const PriceCard = ({ free, left, className, children }) => {
  return (
    <Box
      position={left ? 'absolute' : 'static'}
      left={32}
      column
      width={315}
      height={550}
      p={16}
      alignItems="start"
      gap={24}
      r={16}
      background={free ? '#1E1E1E' : '#0000FF'}
      border="1px solid white"
      shadow="2px 2px 0px 0px white"
      className={className}
      container
    >
      {children}
    </Box>
  )
}